'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface Tab {
  id: string;
  label: string;
  icon: string;
}

interface ProfileTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const ProfileTabs = ({ tabs, activeTab, onTabChange }: ProfileTabsProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/customer-profile/components/ProfileTabs.tsx:27:6" data-component-path="src/app/customer-profile/components/ProfileTabs.tsx" data-component-line="27" data-component-end-line="36" data-component-file="ProfileTabs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-lg%20shadow-warm-md%20p-2%22%7D" className="bg-card rounded-lg shadow-warm-md p-2">
        <div data-component-id="src/app/customer-profile/components/ProfileTabs.tsx:28:8" data-component-path="src/app/customer-profile/components/ProfileTabs.tsx" data-component-line="28" data-component-end-line="35" data-component-file="ProfileTabs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-2%22%7D" className="flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <div data-component-id="src/app/customer-profile/components/ProfileTabs.tsx:30:12" data-component-path="src/app/customer-profile/components/ProfileTabs.tsx" data-component-line="30" data-component-end-line="33" data-component-file="ProfileTabs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-12%20bg-muted%20rounded-md%20flex-1%20min-w-%5B120px%5D%20animate-pulse%22%7D"
              key={tab.id}
              className="h-12 bg-muted rounded-md flex-1 min-w-[120px] animate-pulse"
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div data-component-id="src/app/customer-profile/components/ProfileTabs.tsx:41:4" data-component-path="src/app/customer-profile/components/ProfileTabs.tsx" data-component-line="41" data-component-end-line="58" data-component-file="ProfileTabs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-lg%20shadow-warm-md%20p-2%22%7D" className="bg-card rounded-lg shadow-warm-md p-2">
      <div data-component-id="src/app/customer-profile/components/ProfileTabs.tsx:42:6" data-component-path="src/app/customer-profile/components/ProfileTabs.tsx" data-component-line="42" data-component-end-line="57" data-component-file="ProfileTabs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-2%22%7D" className="flex flex-wrap gap-2">
        {tabs.map((tab) => (
          <button data-component-id="src/app/customer-profile/components/ProfileTabs.tsx:44:10" data-component-path="src/app/customer-profile/components/ProfileTabs.tsx" data-component-line="44" data-component-end-line="55" data-component-file="ProfileTabs.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center justify-center gap-2 px-4 py-3 rounded-md font-medium transition-smooth flex-1 min-w-[120px] focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-2 ${
              activeTab === tab.id
                ? 'bg-primary text-primary-foreground shadow-warm'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            <Icon data-component-id="src/app/customer-profile/components/ProfileTabs.tsx:53:12" data-component-path="src/app/customer-profile/components/ProfileTabs.tsx" data-component-line="53" data-component-end-line="53" data-component-file="ProfileTabs.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={tab.icon as any} size={20} />
            <span data-component-id="src/app/customer-profile/components/ProfileTabs.tsx:54:12" data-component-path="src/app/customer-profile/components/ProfileTabs.tsx" data-component-line="54" data-component-end-line="54" data-component-file="ProfileTabs.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22hidden%20sm%3Ainline%22%7D" className="hidden sm:inline">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProfileTabs;